export default __webpack_public_path__ + "static/media/table6seatUnilateral.325be118.svg";